import React from 'react';
import './Cali.css'; 

const Macarena = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKNA.pdf" target="_blank" rel="noreferrer">Aeropuerto La Macarena</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 17</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNA/UBRI1E.pdf" target="_blank" rel="noreferrer">UBRI1E</a></th>
          </tr>
              
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 35</th>                      
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 17</th>                      
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 35</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNA/IMBI1A.pdf" target="_blank" rel="noreferrer">IMBI1A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 17</th>                      
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 35</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNA/RNP35.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Macarena;